import * as React from 'react';
import { SingleValueComponent } from 'ui/common/types';
import{isValidUrl} from 'app/infrastructure/validation/url'; 
import styles from './display-safe-anchor.scss';

export const DisplaySafeAnchor: React.FC<React.PropsWithChildren<SingleValueComponent<string>>> = (props: SingleValueComponent<string>) => {
  
  const anchorLink = 
                    <a href={props.value} target="_blank"  rel="noopener noreferrer" className={styles.displaySafeAnchor}>        
                      {props.value}        
                    </a>;    

    return (
      <div className={props.className} id={props.componentId}>
        {isValidUrl(props.value) ? anchorLink : props.value}
      </div>
    );        
  };
